  <template>
  <div v-if="logincorrecto != ''" class="home">
    <!-- This is an example component -->
    <div class="font-sans">
      <div
        class="
          relative
          min-h-screen
          flex flex-col
          sm:justify-center
          items-center
          bg-gray-100
        "
      >
        <div class="relative sm:max-w-sm w-full">
          <div
            class="
              card
              bg-blue-400
              shadow-lg
              w-full
              h-full
              rounded-3xl
              absolute
              transform
              -rotate-6
            "
          ></div>
          <div
            class="
              card
              bg-blue-900
              shadow-lg
              w-full
              h-full
              rounded-3xl
              absolute
              transform
              rotate-6
            "
          ></div>
          <div
            class="relative w-full rounded-3xl px-6 py-4 bg-gray-100 shadow-md"
          >
            <label
              for=""
              class="
                block
                text-sm
                mt-10
                text-gray-700 text-center text-xl
                font-semibold
              "
            >
              <img
                height="150"
                width="1100px"
                class="mx-auto"
                src="../assets/HorizontalNegro1.png"
                alt="Workflow"
              />

              <hr />
            </label>

            <div>
              <input
                v-model="user"
                type="user"
                placeholder="   Usuario"
                class="
                  mt-10
                  p-4
                  block
                  w-full
                  border-none
                  bg-gray-100
                  h-11
                  rounded-xl
                  shadow-lg
                  hover:bg-blue-100
                  focus:bg-blue-100
                  focus:ring-0
                "
                required
              />
              <input
                @keyup.enter="prueba(), login(datoss)"
                v-model="pass"
                type="password"
                placeholder="   Contraseña"
                class="
                  mt-4
                  p-4
                  block
                  w-full
                  border
                  bg-gray-100
                  h-11
                  rounded-xl
                  shadow-lg
                  hover:bg-blue-100
                  focus:bg-blue-100
                  focus:ring-0
                "
                required
              />
              <div v-if="alerta" class="w-full text-center mt-2">
                <div class="text-red-500 mx-2 rounded relative">
                  <span> Datos Incorrectos! </span>
                </div>
              </div>
              <button
                @click="prueba(), login(datoss)"
                class="
                  bg-blue-500
                  w-full
                  py-3
                  rounded-xl
                  mt-2
                  text-white
                  shadow-xl
                  hover:shadow-inner
                  focus:outline-none
                  transition
                  duration-500
                  ease-in-out
                  transform
                  hover:-translate-x
                  hover:scale-105
                "
              >
                Entrar
              </button>
            </div>

            <div class="mt-7 shadow rounded bg-gray-100"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { mapState, mapMutations } from "vuex";
//import axios from "axios";
export default {
  name: "Home",
  data() {
    return {
      user: "",
      pass: "",
      data: "",
      token: "",
      datoss: [],
      false: false,
    };
  },

  computed: {
    ...mapState(["numero", "alerta", "logincorrecto"]),
  },

  methods: {
    closeAlert() {
      setTimeout("this.alertadato(this.false)", 5000);
    },

    prueba() {
      this.datoss = {
        login: this.user,
        password: this.pass,
      };
    },
    ...mapMutations(["login", "alertadato"]),
  },
};
</script>
<style scoped>
hr.new2 {
  border-top: 1px dashed red;
}
</style>
